export default {
  styleOverrides: {
    rounded: {
      borderRadius: "100px 100px 10px 100px",
    },
  },
};
